export const stats = [
  { value: "75+", label: "Years of Legacy" },
  { value: "3", label: "Distinct Brands" },
  { value: "Pan-India", label: "Domestic Network" },
  { value: "3", label: "Countries Served" },
];

export const brands = [
  {
    name: "Krish Fashion",
    logo: "/krish-fashion-logo.png",
    division: "Unstitched Dress Materials",
    reach: "Pan-India Distribution",
    description:
      "Our flagship consumer brand, carried by retailers across the country. Krish Fashion has built a household presence in unstitched dress materials nationwide, with deep-rooted strongholds in Delhi NCR and the southern states.",
    markets: ["Delhi NCR — Stronghold", "South India — Stronghold", "Nationwide Retail Network"],
  },
  {
    name: "IOLY",
    logo: "/ioly-logo.png",
    division: "Readymade Garments",
    reach: "Multi-Regional Presence",
    description:
      "IOLY is our contemporary readymade garments label — making waves across western and northern India, and rapidly expanding through the southern metros of Bangalore and Kerala.",
    markets: ["Gujarat", "Rajasthan", "Punjab", "Bangalore", "Kerala"],
  },
  {
    name: "KF Prints",
    logo: "/kf-logo.png",
    division: "Fabrics Division",
    reach: "India & The Gulf",
    description:
      "The fabrics arm of the group, born in Surat — India's textile capital. KF Prints supplies premium printed and finished fabrics to trade partners in Mumbai, and to long-standing export partners in Dubai and Saudi Arabia.",
    markets: ["Surat — Home Base", "Mumbai", "Dubai, UAE", "Saudi Arabia"],
  },
];

export const networkRegions = [
  { zone: "North India", places: ["Delhi NCR", "Punjab", "Rajasthan"] },
  { zone: "West India", places: ["Surat — Headquarters", "Mumbai", "Gujarat"] },
  { zone: "South India", places: ["Bangalore", "Kerala", "Southern Retail Network"] },
];

export const corridor = [
  { city: "Surat", role: "Manufacturing Base" },
  { city: "Mumbai", role: "Trade Gateway" },
  { city: "Dubai", role: "UAE Partnerships" },
  { city: "Saudi Arabia", role: "Gulf Distribution" },
];

export const capabilities = [
  "Export-compliant processes and documentation",
  "Flexible MOQ to suit varied order sizes",
  "Bulk production capability with consistent quality",
  "Timely dispatch & logistics coordination",
  "Multi-currency invoicing support",
  "Dedicated account management for key clients",
];
